/* eslint-disable require-jsdoc */
const carouselSettings = (events, next, getEvents, showHowManySlides) => {
  return {

    // beforeChange: (oldSlideIndex, newSlideIndex, ) => {
    //   // console.log('beforeChange oldSlideIndex, newSlideIndex: ',
    //   //   oldSlideIndex, newSlideIndex);
    //   console.log('carouselSettings.js showHowManySlides',
    //                 showHowManySlides, events.length);
    // },
    
    afterChange: (slideIndex) => {
      // console.log('afterChange slideIndex ' + slideIndex);
      // console.log('afterChange events.length: ', events.length);
      // console.log('my next:', next);
      if (showHowManySlides===5 &&
          (slideIndex+10===events.length || slideIndex+11===events.length) && next) {
        const newOffset=(slideIndex-9)%20===0 ? slideIndex+11: slideIndex+10;
        // console.log('afterChange newOffset before 20 more slides pull, slideIndex', 
        //   newOffset, slideIndex);
        getEvents(newOffset);
      } else if ( showHowManySlides===4 &&
        (slideIndex+8===events.length || slideIndex+9===events.length) && next) {
        const newOffset=(slideIndex-11)%20===0 ? slideIndex+11 : slideIndex+10;
        // console.log('afterChange newOffset before 20 more slides pull, slideIndex', 
        //   newOffset, slideIndex);
        getEvents(newOffset);
      } else if ( showHowManySlides===2 &&
        (slideIndex+4===events.length || slideIndex+5===events.length) && next) {
          const newOffset=(slideIndex-15)%20===0 ? slideIndex+11 : slideIndex+10;
          // console.log('afterChange newOffset before 20 more slides pull, slideIndex', 
          //   newOffset, slideIndex);
        getEvents(newOffset);
      }
      
    },

    dots: false,
    infinite: false,
    speed: 400,
    touchThreshold: 1000,
    slidesToShow: events.length<showHowManySlides ?
      events.length : showHowManySlides,
    slidesToScroll: events.length<showHowManySlides ?
      events.length : showHowManySlides,
    swipe: true,
    touchMove: true,
    arrows: true,    
    className: 'hearby-content-slider',
  };
};

export default carouselSettings;
